import Layout1 from "@/layout/Layout1";

export default [
  {
    path: "/escuela-observadores-democraticos",
    component: Layout1,
    children: [
      {
        path: "detail",
        name: "escuela-observadores-democraticos-detail",
        component: () => import("@/views/volunteering/ViewVoluntariadoEod"),
        meta: {
          title: "Escuela de Observadores Democráticos - Detalle",
          requiresAuth: true
        }
      },
      {
        path: "edit",
        name: "escuela-observadores-democraticos-edit",
        component: () => import("@/views/volunteering/AddEditVoluntariadoEod"),
        meta: {
          title: "Escuela de Observadores Democráticos - Editar",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/voluntariado-eod",
    component: Layout1,
    children: [
      {
        path: "",
        redirect: "/voluntariado-eod/list"
      },
      {
        path: "list",
        name: "voluntariado-eod-list",
        component: () => import("@/views/volunteering/ListVoluntariadoEod"),
        meta: {
          title: "Escuela de Observadores Democráticos - Lista",
          requiresAuth: true
        }
      },
      {
        path: "add",
        name: "voluntariado-eod-add",
        component: () => import("@/views/volunteering/AddEditVoluntariadoEod"),
        meta: {
          title: "Escuela de Observadores Democráticos - Agregar",
          requiresAuth: true
        }
      },
      {
        path: "edit/:id",
        name: "voluntariado-eod-edit",
        component: () => import("@/views/volunteering/AddEditVoluntariadoEod"),
        meta: {
          title: "Escuela de Observadores Democráticos - Editar",
          requiresAuth: true
        }
      },
      {
        path: "detail/:id",
        name: "voluntariado-eod-detail",
        component: () => import("@/views/volunteering/VoluntariadoEodDetail"),
        meta: {
          title: "Escuela de Observadores Democráticos - Detalle",
          requiresAuth: true
        }
      },
      {
        path: "view",
        name: "voluntariado-eod-view",
        component: () => import("@/views/volunteering/ViewVoluntariadoEod"),
        meta: {
          title: "Escuela de Observadores Democráticos - Vista",
          requiresAuth: true
        }
      }
    ]
  }
];
